import { Directive } from '@angular/core';

@Directive({
  selector: '[footerTemplate]',
  standalone: true,
})
export class FooterTemplateDirective {}
